export const LEFT_ALIGN_COLS = new Set([
  "No.",
  "SMILES",
  "Molecule",
  "Viruses",
  "Source IDs",
  "Standard Type",
  "Standard Value",
  "Targets",
]);

export const COLUMN_DESCRIPTIONS: Record<string, React.ReactNode> = {
  "No.": "Order of the molecule in the table",
  "BSA-DB ID": "Unique identifier of the molecule in the BSA-DB database",
  Molecule: "Structural representation of the molecule",
  "Source IDs": "Identifiers of assays from which the data were derived",
  Viruses: "Viruses against which activity has been observed",
  "Number of Viruses": "Number of viruses against which activity was reported",
  "Standard Type": "Activity metric (e.g., IC₅₀, EC₅₀)",
  "Standard Relation": "Relation between value and measurement (=, <, >)",
  "Standard Value": "Numerical activity value",
  "Standard Unit":
    "Unit of the activity measurement. All values are converted to nM",
  Targets: "Biological targets of the molecule",
  "Assay Variability Note":
    'Variability note: marked "Yes" if multiple activity values differ by >10×; otherwise "No"',
  "PubChem ID": "Identifier in the PubChem database",
  "ChEMBL ID": "Identifier in the ChEMBL database",
  "BindingDB ID": "Identifier in the BindingDB database",
  "Calculated MW":
    "Predicted molecular weight. Calculated using RDKit rdkit.Chem.Descriptors.MolWt",
  "Calculated logP":
    "Predicted octanol–water partition coefficient. Calculated using RDKit rdkit.Chem.Crippen.MolLogP",
  "Calculated HBD":
    "Predicted number of hydrogen bond donors. Calculated using RDKit rdkit.Chem.Lipinski.NumHDonors",
  "Calculated HBA":
    "Predicted number of hydrogen bond acceptors. Calculated using RDKit rdkit.Chem.Lipinski.NumHAcceptors",
  "Calculated TPSA":
    "Predicted topological polar surface area. Calculated using RDKit rdkit.Chem.rdMolDescriptors.CalcTPSA",
  "Calculated RotB":
    "Predicted number of rotatable bonds. Calculated using RDKit rdkit.Chem.Lipinski.NumRotatableBonds",
  QED: "Quantitative Estimate of Drug-likeness score (Bickerton et al., 2012). Calculated using RDKit rdkit.Chem.QED.qed",
  "SA Score":
    "Synthetic accessibility score (Ertl & Schuffenhauer, 2009). Calculated using RDKit rdkit.Chem.SA_Score.sascorer",
  "Cluster ID":
    "Cluster ID assigned to each molecule based on the clustering approach described in this paper.",
  "HADES Score": (
    <>
      ML-based soft-voting oral drug-likeness score (Petrosyan et al., 2026),
      calculated using the original paper's{" "}
      <a
        href="https://github.com/Narek-Petros-yan/HADES"
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer text-contentBrand underline-offset-2 hover:underline">
        GitHub Code
      </a>
      .
    </>
  ),
};
